import React, { useState, useEffect, useCallback } from 'react';
import '../../styles/common.css';

const Tabs = ({ titles, components, setCurrentTab }) => {
  const [selected, setSelected] = useState(0);

  useEffect(() => {
    handleSelection(0)();
  }, []);

  const handleSelection = useCallback((selectedIndex) => (e) => {
    if (e) {
      e.stopPropagation();
    }
    setSelected(selectedIndex);
    if (setCurrentTab) {
      setCurrentTab(selectedIndex);
    }
  }, [setCurrentTab]);

  // Early return if no titles or components
  if (!titles || !components || titles.length === 0 || components.length === 0) {
    return <div>No tabs to display</div>;
  }

  return (
    <div id="tabs-component">
      <div className="titles">
        {titles.map((name, ind) => (
          <div
            className={selected === ind ? 'selected' : ''}
            key={ind}
            onClick={handleSelection(ind)}
            role="tab"
            tabIndex={0}
            aria-selected={selected === ind}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleSelection(ind)(e);
              }
            }}
          >
            {name}
          </div>
        ))}
      </div>
      <div className="components">
        <div role="tabpanel">
          {components[selected]}
        </div>
      </div>
    </div>
  );
};

export default Tabs;
